
/* eslint-disable: import/no-anonymous-default-export */

export const getToken = () => localStorage.getItem('token')
export const setToken = token => localStorage.setItem('token', token)
export const clearToken = () => localStorage.removeItem('token')

export const getPersistedOrg = () => JSON.parse(localStorage.getItem('org'))
export const persistSelectedOrg = org => localStorage.setItem('org', JSON.stringify(org))
export const clearPersistedOrg = () => localStorage.removeItem('org')